import { getLocalTimeZone } from '@internationalized/date';
import { useMemo } from 'react';
import { useGlobal } from '@/store';
import { useContentReview } from '@/store/content-review';
import { toUnix } from '@/utils/date';
import { QuestionReviewFiltersSection } from './components/filters-section';
import { QuestionReviewsTable } from './components/list';

export const QuestionReviewPage = () => {
  const search = useContentReview.use.search();
  const createdAt = useContentReview.use.createdAt();
  const createdBy = useContentReview.use.createdBy();
  const recordIds = useContentReview.use.recordIds();
  const type = useContentReview.use.type();
  const state = useContentReview.use.state();
  const dbType = useGlobal.use.dbType();
  const actionedBy = useContentReview.use.actionedBy();

  const createdAtUnix = useMemo(() => {
    if (!createdAt) return undefined;
    const date = createdAt.toDate ? createdAt.toDate(getLocalTimeZone()) : new Date(createdAt.toString());
    return toUnix(date);
  }, [createdAt]);

  const filterKey = useMemo(
    () => JSON.stringify({ search, createdAtUnix, createdBy, recordIds, type, state, dbType }),
    [search, createdAtUnix, createdBy, recordIds, type, state, dbType],
  );

  return (
    <div className='flex flex-col h-full gap-4'>
      <QuestionReviewFiltersSection />
      <div className='overflow-x-auto w-full'>
        <QuestionReviewsTable
          filterKey={filterKey}
          search={search}
          createdAtUnix={createdAtUnix}
          createdBy={createdBy}
          recordIds={recordIds}
          type={type}
          state={state}
          actionedBy={actionedBy}
          title='Record Reviews'
        />
      </div>
    </div>
  );
};
